import { render } from "./ethetical-canopy-x-behno.vue?vue&type=template&id=6ba4c630&scoped=true"
import script from "./ethetical-canopy-x-behno.vue?vue&type=script&lang=js"
export * from "./ethetical-canopy-x-behno.vue?vue&type=script&lang=js"

import "./ethetical-canopy-x-behno.vue?vue&type=style&index=0&id=6ba4c630&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba4c630"]])

export default __exports__